import React from 'react';
import { css } from '@emotion/core';
import { useAllocatedHeight } from '../app.use/useAllocatedHeight';
import { VSpace } from '../utils.styles/system';
import { Heading } from '../utils.styles/Heading';
import { SystemBox } from '@whop/system';
import { PageLayoutProps } from '../app.types/pages';
import { PageBreadcrumbsView } from '../tsx.app.global/PageBreadcrumbsView';

export function CenteredLayout(
  props: PageLayoutProps & { center?: 'full' | 'horizontal'; noPadding?: boolean }
) {
  const { center = 'full', noPadding } = props;

  const allocatedHeight = useAllocatedHeight();

  const headingEl = props.headingEl || <Heading>{props.headingTitle}</Heading>;

  const showBreadcrumbs = !props.flags?.noBreadcrumbs;
  return (
    <React.Fragment>
      {showBreadcrumbs && (
        <React.Fragment>
          <PageBreadcrumbsView />
          <VSpace />
        </React.Fragment>
      )}

      <SystemBox
        system={noPadding ? { padding: [0] } : { padding: [1, 2, 3] }}
        css={css`
          min-height: calc(100vh - ${allocatedHeight}px);
          display: flex;
          flex-direction: column;
          justify-content: ${center === 'full' ? 'center' : undefined};
          align-items: center;
          box-sizing: border-box;
        `}
      >
        {headingEl ? (
          <React.Fragment>
            {headingEl}
            <VSpace size={3} />
          </React.Fragment>
        ) : null}
        {props.children}
      </SystemBox>
    </React.Fragment>
  );
}
